import * as React from 'react';
import { useState, useEffect } from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import { initializeApp } from 'firebase/app';
import { getFirestore, addDoc, collection, onSnapshot, orderBy, limit, query, where } from 'firebase/firestore'

// Connect to current firebase project
const firebaseApp = initializeApp({
  apiKey: "AIzaSyBamRPS6NxxPg7lplFrxZd36fLWg9ZUTDY",
  authDomain: "ambient-systems.firebaseapp.com",
  databaseURL: "https://ambient-systems-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "ambient-systems",
  storageBucket: "ambient-systems.appspot.com",
  messagingSenderId: "1001740093061",
  appId: "1:1001740093061:web:b516ca06c0e80199b90bec"
});
const firestore = getFirestore(firebaseApp);

/* Identify the current user */
const user_email = window.localStorage.getItem('user_email');

export default function FeedSettings(source) {
  const [open, setOpen] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);

  const [name, setName] = useState([])
  const [type, setType] = useState([])
  const [portfolio, setPortfolio] = useState([])
  const [building, setBuilding] = useState([])
  const [strata, setStrata] = useState([])

  const [choice1, setChoice1] = useState(false)
  const [choice2, setChoice2] = useState(false)
  const [choice3, setChoice3] = useState(false)
  const [choice4, setChoice4] = useState(false)
  const [choice5, setChoice5] = useState(false)
  const [choice6, setChoice6] = useState(false)

  const handleClose = () => {
    setOpen(false);
    setName([]);
    setType([]);
    setPortfolio([]);
    setBuilding([]);
    setStrata([]);
  };

  const handleClose2 = () => {
    setOpen2(false);
    setName([]);
    setType([]);
    setPortfolio([]);
    setBuilding([]);
    setStrata([]);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  // Query the data feed Id for different user
  const [ID, setID] = useState();
  useEffect(() => {
      const idQuery = query(
          collection(firestore, 'connectors'),
          where('user_email', '==', user_email),
          limit(1),
          orderBy('id', 'desc')
      );
      onSnapshot(idQuery, snapshot => {
          const t = (snapshot.docs.map(doc => ({ id: doc.data().id })))
          if (!t[0]) {
              setID('0')
          } else {
              setID(JSON.stringify(t[0].id))
          }
      })
      }, [])

    function handleNext(e) {
        e.preventDefault()
        if (name == "" || type == "" || portfolio == "" || building == "" || strata == "") {
            alert("Please give all the information required below!")
            return 
        }
        if (source.source.name=="") {
            alert("No file attached! Please upload your data first.")
            return
        }

        setOpen(false);
        // setOpen2(true);

        const CollectionRef = collection(firestore, 'connectors')
        const dataEdit = new Date()
        const id = Number(ID) + 1
        const dataType = type
        const status = "50%"
        const file = source.source.name
        const method = source.source.method
        const models = []

        addDoc(CollectionRef, {dataEdit, dataType, id, name, status, portfolio, building, strata, user_email, file, method, models})
        .then(response => {
            console.log(response.id)
            const fileId = response.id
            alert("Set successfully! Please check it on <Data Feeds> page.")
        })
        .catch(error => {
            console.log(error.message)
            alert(error.message)
        })

        const email = user_email
        const content = "Created a new feed : " + name
        const date = formatDate()
        const time = new Date()
        addDoc(collection(firestore, 'alerts'), {email, content, date, time})
        handleClose()
    }

    function formatDate() {
        var d = new Date(),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
    
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;
    
        return [year, month, day].join('-');
    }

  function handleSubmit(e) {    
    var modelList = []

    if (choice1) {
        modelList.push("Model1")
    }
    if (choice2) {
        modelList.push("Model2")
    }
    if (choice3) {
        modelList.push("Model3")
    }
    if (choice4) {
        modelList.push("Model4")
    }
    if (choice5) {
        modelList.push("Model5")
    }
    if (choice6) {
        modelList.push("Model6")
    }

    const CollectionRef = collection(firestore, 'connectors')
    const dataEdit = new Date()
    const id = Number(ID) + 1
    const dataType = type
    const status = "50%"
    const file = source.source.name
    const method = source.source.method
    const models = modelList

    addDoc(CollectionRef, {dataEdit, dataType, id, name, status, portfolio, building, strata, user_email, file, method, models})
        .then(response => {
        console.log(response.id)
        const fileId = response.id

        if (models.length > 0) {
            models.forEach((model) => {
                addDoc((collection(firestore, 'feedToModel')), {user_email, model, fileId, name})
            })
        }

        alert("Set successfully! Please check it on <Data Feeds> page.")
        })
        .catch(error => {
        console.log(error.message)
        alert(error.message)
        })

    const email = user_email
    const content = "Created a new feed : " + name
    const date = formatDate()
    const time = new Date()
    addDoc(collection(firestore, 'alerts'), {email, content, date, time})

    handleClose2()
    }

  return (
    <div>
        {/* <Typography variant="h7" sx={{ mt: 1, mr: 1 }} >Set up this feed:</Typography> */}
            <Button
                variant="contained" color="secondary" onClick={handleClickOpen}
            >
                Set Up
            </Button>

        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Custom Data</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Please fill in these fields to label your data.
                </DialogContentText>

                <FormControl sx={{ mt: 2, mb: 2, minWidth: 500 }}>
                    <TextField autoFocus margin="dense" id="name" label="Name this feed" fullWidth variant="standard" onChange={(e) => {setName(e.target.value)}} />
                    <TextField autoFocus margin="dense" id="type" label="Data type" fullWidth variant="standard" onChange={(e) => {setType(e.target.value)}} />
                    <TextField autoFocus margin="dense" id="portfolio" label="Portfolio it is related to" fullWidth variant="standard" onChange={(e) => {setPortfolio(e.target.value)}} />
                    <TextField autoFocus margin="dense" id="building" label="Building it is for" fullWidth variant="standard" onChange={(e) => {setBuilding(e.target.value)}} />
                    <TextField autoFocus margin="dense" id="strata" label="Strata" fullWidth variant="standard" onChange={(e) => {setStrata(e.target.value)}} />
                </FormControl>
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={handleNext}>Next Step</Button>
            </DialogActions>
        </Dialog>

        <Dialog open={open2} onClose={handleClose2}>
            <DialogTitle>Add Models</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Please choose the models that you'd like to attach with this feed.
                </DialogContentText>

                <FormGroup sx={{ mt: 5, mb: 2, ml: 5 }}>
                    <FormControlLabel control={<Checkbox checked={choice1} onChange={e => setChoice1(!choice1)}/>} label="Model1" />
                    <FormControlLabel control={<Checkbox checked={choice2} onChange={e => setChoice2(!choice2)}/>} label="Model2" />
                    <FormControlLabel control={<Checkbox checked={choice3} onChange={e => setChoice3(!choice3)}/>} label="Model3" />
                    <FormControlLabel control={<Checkbox checked={choice4} onChange={e => setChoice4(!choice4)}/>} label="Model4" />
                    <FormControlLabel control={<Checkbox checked={choice5} onChange={e => setChoice5(!choice5)}/>} label="Model5" />
                    <FormControlLabel control={<Checkbox checked={choice6} onChange={e => setChoice6(!choice6)}/>} label="Model6" />
                </FormGroup>
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose2}>Cancel</Button>
                <Button onClick={handleSubmit}>Submit</Button>
            </DialogActions>
        </Dialog>
    </div>
  );
}